// change password
export const changePasswordFormDefaults = {
  password: '',
  password_confirmation: ''
};

// station services
export const updateProfileDefaults = {
  name: '',
  surname: '',
  email: '',
  telephone: '',
  birthdate: ''
};

// User List filter form defaults
export const filterUsersDefaults = {
  name: '',
  surname: '',
  title: ''
};

// System User CRUD form defaults
export const addEditSystemUserDefaults = {
  name: '',
  surname: '',
  title: '',
  role_id: '',
  email: '',
  telephone: '',
  birthdate: '',
  tckn: '',
  password: '',
  password_confirmation: ''
};

// Pharmacy Crud
export const addEditPharmacyDefaults = {
  name: '',
  telephone: '',
  attendant: '',
  second_telephone: '',
  attendant_telephone: '',
  email: '',
  address: '',
  city_id: '',
  district_id: '',
  region_id: ''
};

// Pharmacy Filter
export const filterPharmacies = {
  city_id: '',
  district_id: '',
  name: '',
  is_turp_pharmacy: '',
  is_pharmacy_on_duty: '',
  min_duty_date: '',
  max_duty_date: ''
};

export const filterPharmacyUsers = {
  fullname: '',
  telephone: '',
  email: ''
};

export const addEditPharmacyUsersDefaults = {
  full_name: '',
  telephone: '',
  email: '',
  password: '',
  password_confirmation: '',
  role_id: ''
};

export const filterPharmacySupportDefaults = {
  pharmacy_name: '',
  subject: '',
  start_date: '',
  end_date: ''
};

export const filterCustomersDefaults = {
  name: '',
  surname: '',
  email: '',
  telephone: ''
};

export const filterCustomersOrders = {
  order_no: '',
  order_statuses: '',
  min_order_date: '',
  max_order_date: ''
};

export const filterCustomerContactUsDefaults = {
  name: '',
  surname: '',
  start_date: '',
  end_date: ''
};

export const filterCampaignListDefaults = {
  start_date: '',
  end_date: '',
  name: ''
};

// Campaign CRUD form defaults
export const addEditCampaignDefaults = {
  name: '',
  description: '',
  start_date: null,
  end_date: null,
  content: '',
  sms_notification_enabled: false,
  email_notification_enabled: false,
  push_notification_enabled: false
};

// Campaign Pharmacies Filter form defaults
export const filterCampaignPharmaciesDefaults = {
  pharmacy_name: '',
  city_id: '',
  district_id: ''
};

// Campaign Add Pharmacies Filter form defaults
export const filterCampaignPharmaciesAddDefaults = {
  filter: '',
  city_id: '',
  district_id: ''
};
